import fetch from '@/utils/fetch';
import {systemFetch} from '@/utils/fetch';

//公共模板列表
export function publicTempalteList(schoolTypeId,currId) {
    let params = new URLSearchParams();
    params.append('currId', currId);
    params.append('schoolTypeId', schoolTypeId);
    return fetch({
      url: 'structure/examPlatformSet/publicTemplateList',
      method: 'get',
      params
    });
  }
//删除模板
export function deleteTempalte(templateId) {
    let params = new URLSearchParams();
    params.append('templateId', templateId);
    return fetch({
      url: 'structure/examPlatformSet/deleteTemplate',
      method: 'get',
      params
    });
  }
//根据学段获取科目
export function getCurrBySchoolType(schoolType) {
    let params = new URLSearchParams();
    params.append('schoolType', schoolType);
    return systemFetch({
      url: 'common/getCurrBySchoolType',
      method: 'get',
      params
    });
  }
//学科题型列表
export function currQuestionList(args) {
    let params = new URLSearchParams();
    params.append('searchName', args.searchName);
    params.append('pageNo', args.pageNo);
    params.append('pageSize', args.pageSize);
    return fetch({
      url: 'structure/examPlatformSet/currQuestionList',
      method: 'get',
      params
    });
}
//删除学科题目
export function deleteCurrQuestion(id) {
    let params = new URLSearchParams();
    params.append('id', id);
    return fetch({
      url: 'structure/examPlatformSet/deleteCurrQuestion',
      method: 'get',
      params
    });
  }
//新增学科题型
export function insertCurrQuestion(args) {
  let params = new URLSearchParams();
  params.append('currId', args.currId);
  params.append('currName', args.currName);
  params.append('relationJson', args.relationJson);
  params.append('schoolType', args.schoolType);
  params.append('schoolTypeName', args.schoolTypeName);
  return fetch({
    url: 'structure/examPlatformSet/insertCurrQuestion',
    method: 'post',
    data:params
  });
}
//编辑学科题型
export function editCurrQuestion(args) {
  let params = new URLSearchParams();
  params.append('currId', args.currId);
  params.append('currName', args.currName);
  params.append('relationJson', args.relationJson);
  params.append('schoolType', args.schoolType);
  params.append('id', args.id);
  params.append('schoolTypeName', args.schoolTypeName);
  return fetch({
    url: 'structure/examPlatformSet/editCurrQuestion',
    method: 'post',
    data:params
  });
}
//根据字典code获得字典数据
export function findDicsByCode() {
  let params = new URLSearchParams();
  params.append('dicCode', 'question');
  return fetch({
    url: 'structure/sysDictionary/findDicsByCode',
    method: 'post',
    data:params
  });
}
//获取学科题型详情
export function currQuestionDetails(id) {
  let params = new URLSearchParams();
  params.append('id', id);
  return fetch({
    url: 'structure/examPlatformSet/currQuestionDetails',
    method: 'get',
    params
  });
}
//根据科目id获取题目
export function getCurrQuestion(currId) {
  let params = new URLSearchParams();
  params.append('currId', currId);
  return fetch({
    url: 'structure/examPlatformSet/getCurrQuestion',
    method: 'get',
    params
  });
}
//新增模板
export function insertTemplate(query) {
  let params = new URLSearchParams();
  params.append('currId', query.currId);//	学科id
  params.append('currName', query.currName);//学科名称
  params.append('isBig', query.isBig);//大题1，小题0
  params.append('isPublic',  query.isPublic);//公共模板传1
  params.append('questionJson', query.questionJson);//题目    
  params.append('schoolPublic', query.schoolPublic);//	是否供全校使用，1代表可以
  params.append('templateName', query.templateName);//模板名称
  params.append('schoolType',  query.schoolType);//	学校类型名称
  params.append('schoolTypeId',  query.schoolTypeId);//学校类型
  params.append('schoolId',query.schoolId);//学校id
  params.append('orderWay',query.orderWay);//排序方式，默认0,0代表所有小题题号顺序排，1代表每大题下的小题重新排序  
  return fetch({
      url: 'structure/examPlatformSet/insertTemplate',
      method: 'POST',
      data:params
  });
}
//编辑模板
export function editTemplate(query) {
  let params = new URLSearchParams();
  params.append('id', query.id);//模板id
  params.append('currId', query.currId);//	学科id
  params.append('currName', query.currName);//学科名称
  params.append('isBig', query.isBig);//大题1，小题0
  params.append('isPublic',  query.isPublic);//公共模板传1
  params.append('questionJson', query.questionJson);//题目    
  params.append('schoolPublic', query.schoolPublic);//	是否供全校使用，1代表可以
  params.append('templateName', query.templateName);//模板名称
  params.append('schoolType',  query.schoolType);//	学校类型名称
  params.append('schoolTypeId',  query.schoolTypeId);//学校类型
  params.append('schoolId',query.schoolId);//公共模板传0   
  params.append('orderWay',query.orderWay);//排序方式，默认0,0代表所有小题题号顺序排，1代表每大题下的小题重新排序 
  return fetch({
      url: 'structure/examPlatformSet/editTemplate',
      method: 'POST',
      data:params
  });
}
//模板详情
export function getTempalteDetails(templateId) {
  let params = new URLSearchParams();
  params.append('templateId', templateId);//	模板id
  return fetch({
      url: 'structure/examPlatformSet/getTemplateDetails',
      method: 'POST',
      data:params
  });
}


// WEBPACK FOOTER //
// ./src/api/achievement.js